import { createSelector } from '@ngrx/store';
import * as fromReducer from '../reducers/browser.reducer';

export const getBrowserSizeName = createSelector(fromReducer.getBrowserFeatureState, fromReducer.getBrowserSizeName);

export const getBrowserWidth = createSelector(fromReducer.getBrowserFeatureState, fromReducer.getBrowserWidth);

export const getBrowserHeight = createSelector(fromReducer.getBrowserFeatureState, fromReducer.getBrowserHeight);
